import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const userApi = createApi({
  reducerPath: 'user',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/' }),
  endpoints: (builder) => ({
    getUser: builder.query({
      query: () => ({url: 'session/'}),
      // transformResponse: (response, meta, arg) => {        
      //   console.log(meta.response.headers)
      //   return response
      // },
    }),
  }),
});
export const {
  useGetUserQuery
} = userApi